module.exports = __webpack_public_path__ + "img/icon-cross.2d32b067.svg";